"use client";

import { useEffect, useState } from "react";

export default function HeaderSearchTrigger() {
  const [shortcutKey, setShortcutKey] = useState("Ctrl");

  useEffect(() => {
    if (typeof navigator !== "undefined" && /Mac|iPhone|iPad/i.test(navigator.platform)) {
      setShortcutKey("⌘");
    }
  }, []);

  const open = () => {
    window.dispatchEvent(new Event("open-command-palette"));
  };

  return (
    <button
      type="button"
      onClick={open}
      aria-label="Open search"
      className="flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-1.5 text-sm text-gray-500 transition-colors hover:border-gray-300 hover:bg-white hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:border-gray-600 dark:hover:bg-gray-900 dark:hover:text-gray-200"
    >
      <svg
        className="h-4 w-4"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        aria-hidden="true"
      >
        <circle cx="8.5" cy="8.5" r="5.5" />
        <path d="M12.5 12.5L17 17" strokeLinecap="round" />
      </svg>
      <span className="hidden sm:inline">Search tools…</span>
      <kbd className="hidden shrink-0 rounded border border-gray-200 bg-white px-1.5 py-0.5 text-[10px] font-medium text-gray-500 sm:inline-flex dark:border-gray-600 dark:bg-gray-900 dark:text-gray-400">
        {shortcutKey}K
      </kbd>
    </button>
  );
}
